import { useMutation, useQuery } from "react-query";
import guidelinesApi from "../apis/guidelines";
const {
  fetchGetAllCategories,
  fetchGetAllSubCategories,
  createNewCategory,
  createNewSubCategory,
  createNewAngle,
  fetchGetAllAngles,
  createNewMarketPlace,
  fetchGetAllMarketPlace,
  fetchGetAllMarketPlaceCategories,
  fetchGetAllMarketPlaceSubCategories,
  addCategoryToMarketPlace,
  addSubCategoryToMarketPlace,
  fetchGetAllMergedGuidelines,
  addAngleSetToMarketPlace,
  deleteAngleSet,
  fetchAllAngleListShootTypes,
  fetchGuidelineData,
  updateAngleSetToMarketPlace,
  fetchAllOrganization,
  fetchPendingRequests,
  markUnderReview,
  createDuplicateAngleSet,
  skuGuidelineDetails
} = guidelinesApi;

export const useGetAllCategorises = (
  remark,
  pageNum,
  pageSize,
  searchName,
  onSuccess,
  onError
) =>
  useQuery(
    ["" + remark, pageNum, pageSize, searchName],
    () => fetchGetAllCategories(pageNum, pageSize, searchName),
    {
      onSuccess,
      onError,
    }
  );
export const useGetAllSubCategorises = (
  remark,
  category,
  pageNum,
  pageSize,
  searchName,
  onSuccess,
  onError
) =>
  useQuery(
    ["" + remark, category, pageNum, pageSize, searchName],
    () => fetchGetAllSubCategories(category, pageNum, pageSize, searchName),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    }
  );

export const useCreateNewCategory = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return createNewCategory(payload);
    },
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
};
export const useCreateNewSubCategory = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return createNewSubCategory(payload);
    },
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
};
export const useCreateNewAngle = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return createNewAngle(payload);
    },
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
};

export const useCreateNewMarketPlace = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return createNewMarketPlace(payload);
    },
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
};

export const useGetAllAngles = (
  remark,
  category,
  subCategory,
  orgId,
  pageNum,
  pageSize,
  onSuccess,
  onError
) =>
  useQuery(
    ["" + remark, category, subCategory, orgId, pageNum, pageSize],
    () => fetchGetAllAngles(category, subCategory, orgId, pageNum, pageSize),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    }
  );

export const useGetAllMarketPlace = (
  remark,
  orgId,
  pageNum,
  pageSize,
  onSuccess,
  onError
) =>
  useQuery(
    ["" + remark, orgId, pageNum, pageSize],
    () => fetchGetAllMarketPlace(orgId, pageNum, pageSize),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    }
  );

export const useGetAllMarketPlaceCategories = (
  remark,
  marketplace,
  orgId,
  onSuccess,
  onError
) =>
  useQuery(
    ["" + remark, marketplace, orgId],
    () => fetchGetAllMarketPlaceCategories(marketplace, orgId),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    }
  );

export const useGetAllMarketPlaceSubCategories = (
  remark,
  category,
  marketplace,
  orgId,
  onSuccess,
  onError
) =>
  useQuery(
    ["" + remark, category, marketplace, orgId],
    () => fetchGetAllMarketPlaceSubCategories(category, marketplace, orgId),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    }
  );

export const useAddCategoryToMarketPlace = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return addCategoryToMarketPlace(payload);
    },
    onSuccess,
    onError,
  });
};

export const useAddSubCategoryToMarketPlace = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return addSubCategoryToMarketPlace(payload);
    },
    onSuccess,
    onError,
  });
};
export const useAddAngleSetToMarketPlace = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return addAngleSetToMarketPlace(payload);
    },
    onSuccess,
    onError,
  });
};
export const useUpdateAngleSetToMarketPlace = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return updateAngleSetToMarketPlace(payload);
    },
    onSuccess,
    onError,
  });
};
export const useGetAllMergedGuidelines = (
  remark,
  category,
  subCategory,
  marketplace,
  onSuccess,
  onError
) =>
  useQuery(
    ["" + remark, category, subCategory, marketplace],
    () => fetchGetAllMergedGuidelines(category, subCategory, marketplace),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    }
  );

export const useDeleteAngleSet = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return deleteAngleSet(payload);
    },
    onSuccess,
    onError,
  });
};
export const useCreateDuplicateAngleSet = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return createDuplicateAngleSet(payload);
    },
    onSuccess,
    onError,
  });
};
export const useGetAllShootTypes = (remark, onSuccess, onError) =>
  useQuery(["" + remark], () => fetchAllAngleListShootTypes(), {
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
// export const useGetGuidelineData = (remark, guidelineId, onSuccess, onError) =>
//   useQuery(["" + remark], () => fetchGuidelineData(guidelineId), {
//     onSuccess,
//     onError,
//     refetchOnWindowFocus: false,
//   });


export const useGetGuidelineData = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (guidelineId) => fetchGuidelineData(guidelineId),
    onSuccess,
    onError,
  });
};

export const useGetAllOrganization = (
  remark,
  pageNum,
  pageSize,
  onSuccess,
  onError
) =>
  useQuery(
    ["" + remark, pageNum, pageSize],
    () => fetchAllOrganization(pageNum, pageSize),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    }
  );

export const useGetPendingRequests = (
  remark,
  pageNum,
  pageSize,
  requestType,
  onSuccess,
  onError
) =>
  useQuery(
    ["" + remark, pageNum, pageSize, requestType],
    () => fetchPendingRequests(pageNum, pageSize, requestType),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    }
  );

export const useMarkUnderReview = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return markUnderReview(payload);
    },
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
};

export const useGetSkuGuidelines = (remark,skuId,pageNum, pageSize, onSuccess, onError) =>
  useQuery(["" + remark, skuId], () => skuGuidelineDetails(skuId), {
    pageNum,
    pageSize,
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
